import React, { PropTypes, Component } from 'react';

import SchedulingReports from '../SchedulingReports';

import { getScheduledReports } from '../helper';
import { getUserReports, getTotalSchedulingReports, getReportsCCAndCountry } from '../selector';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';

class MyReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduled: 'all'
    };
  }

  componentWillMount() {
    this.fetchReports(this.props.country.value, this.props.costcenter.value);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.country.value !== nextProps.country.value ||
      this.props.costcenter.value !== nextProps.costcenter.value)
      {
        this.fetchReports(nextProps.country.value, nextProps.costcenter.value);
      }
  }

  fetchReports(countrycode, companycode) {
    const roleIdParam = sessionStorage.getItem('roleId') ? {roleId: sessionStorage.getItem('roleId')} : {};
    const fetchParam = Object.assign({}, roleIdParam, { countrycode }, { companycode });
    this.props.actions.fetchReports(fetchParam);
  }

  switchScheduled = tab => {
    this.setState({
      scheduled: tab.key
    });
  };

  render() {
    const { reports, actions, fetchingReports, filteredReports, total } = this.props;
    const { scheduled } = this.state;

    let filteredUserReports = filteredReports;

    if (scheduled === 'scheduled') {
      filteredUserReports = getScheduledReports(filteredUserReports);
    }

    return (
      <SchedulingReports
        fetchingReports={fetchingReports}
        exportReport={actions.exportReport}
        switchScheduled={this.switchScheduled}
        scheduled={scheduled}
        total={total}
        reports={filteredUserReports}
        category="user"
      />
    );
  }
}

MyReports.propTypes = {
  fetchingReports: PropTypes.bool,
  actions: PropTypes.object,
  total: PropTypes.object,
  filteredReports: PropTypes.array
};

const mapStateToProps = state => {
  const { fetchingReports } = state.reports;
  const { costcenter, country } = getReportsCCAndCountry(state);

  return {
    country,
    costcenter,
    fetchingReports,
    filteredReports: getUserReports(state),
    total: getTotalSchedulingReports(state)
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(MyReports);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/my-reports/MyReports.js